import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { useAppSelector } from "../../../../../hooks/app";
import { ROLES } from "../../../../../constants";

function EndorsementOfUs({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [documentType, setDocumentType] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has presented me a ${documentType} [type of document presented, such as U.S. birth certificate or U.S. passport, and relevant control or sequential number on the document, if establishing that [he or she] is a U.S. citizen or national in accordance with 49 CFR §1552.3(h).`;
    dispatch(setTemplateText(templateText));
  }, [name, documentType, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.101(j)</label>
      </div>
      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that
          <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has presented me a
          <input
            type="text"
            onChange={(e) => setDocumentType(e.target.value)}
            style={{ margin: '0 5px' }}
          /> [type of document presented, such as U.S. birth certificate or U.S. passport, and relevant control or sequential number on the document, if any] establishing that [he or she] is a U.S. citizen or national in accordance with 49 CFR §1552.3(h).
        </p>
      </div>
    </TemplateLayout>
  );
}

export default EndorsementOfUs;
